<button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon">close</mat-icon>
</button>

<div class="content-wrapper">
    <div class="container-xxl flex-grow-1 container-p-y">

        <div class="row">
            <div class="col-md-12">
                <div class="mat-dialog-title">
                    <mat-icon class="nav-icon">person_add</mat-icon>Add New Vendor
                </div>
            </div>
        </div>

        <div class="mat-dialog-content">
            <form [formGroup]="vendorDetails" (ngSubmit)="onSubmit()">
                <div class="col-md-12">
                    <mat-form-field appearance="outline">
                        <mat-label>Vendor Name</mat-label>
                        <input matInput formControlName="vendorId" autofocus
                            [ngClass]="{'is-invalid':submitted && forms.vendorId.errors}" required>
                        <mat-error *ngIf="submitted && forms.vendorId.errors" class="invalid-feedback">
                            <div *ngIf="forms.vendorId.errors.required">Address is required</div>
                            <div *ngIf="forms.vendorId.errors.minlength">Minimum length is 2</div>
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-md-12">
                    <mat-form-field appearance="outline">
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="email"
                            [ngClass]="{'is-invalid' : submitted && forms.email.errors}" required>
                        <mat-error *ngIf="submitted && forms.email.errors " class="invalid-feedback">
                            <div *ngIf="forms.email.errors.required">This feild is required
                            </div>
                            <div *ngIf="forms.email.errors.email">Email must be a valid email
                                address</div>

                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-md-12">
                    <mat-form-field appearance="outline">
                        <mat-label>Phone Number</mat-label>
                        <input matInput formControlName="phone" (keypress)="onPress($event)" placeholder="XXX-XXX-XXXX"
                            [ngClass]="{'is-invalid':submitted && forms.phone.errors}" required appPhoneMask appNumericOnly autocomplete="off">
                        <mat-error *ngIf="submitted && forms.phone.errors " class="invalid-feedback">
                            <div *ngIf="forms.phone.errors.required">Phone Number is required
                            </div>
                            <div *ngIf="forms.phone.errors.pattern">Please, Enter 10 digit Mobile
                                Number</div>
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-md-12">
                    <mat-form-field appearance="outline" class="example-full-width">
                        <mat-label>Address</mat-label>
                        <textarea input matInput formControlName="addr1"
                            [ngClass]="{'is-invalid':submitted && forms.addr1.errors}" required></textarea>
                        <mat-error *ngIf="submitted && forms.addr1.errors" class="invalid-feedback">
                            <div *ngIf="forms.addr1.errors.required">Address is required</div>
                        </mat-error>
                    </mat-form-field>
                </div>
                <!-- <div class="col-md-12">
                    <mat-checkbox color="primary" #confirmed>I agree to privacy policy & terms</mat-checkbox>
                </div> -->

                <div class="buttonRow">
                    <button mat-raised-button type="submit" class="button" [disabled]="vendorDetails.invalid"
                        (click)="onNoClick()">Create</button>
                    <button type="reset" mat-raised-button [mat-dialog-close]="true" class="buttonReset">Cancel</button>
                </div>
            </form>
        </div>
    </div>
</div>